import { Theme, color, radius, rem } from '@thiememeulenhoff/lit-sdk';
import * as token from '@thiememeulenhoff/tokens/core';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../../helpers';

export const tag = tagName('content-modal');
const theme = new Theme(tag);

export const styles = [
  css`
    :where(dialog) {
      ${theme.props([
        ['background', 'background', color('white')],
        ['border-radius', 'border-radius', radius('medium')],
      ])};

      min-inline-size: ${rem(740)};

      @media (max-width: ${unsafeCSS(token.BreakpointSmall)}) {
        min-inline-size: 90vw;
      }
    }

    :where(dialog[open]) {
      display: flex;
      flex-direction: column;

      :where(.content-wrapper) {
        overflow-y: auto;
      }
    }

    :where(container) {
      display: flex;
      flex-direction: column;
      gap: ${rem(12)};
      padding: ${rem(20)};

      &.has-header {
        gap: 0;
        padding-block-start: 0;
        padding-inline: 0;

        header {
          padding-block-end: ${rem(12)};
          padding-block-start: ${rem(20)};
          ${theme.props([['background', 'background', color('white')]])};
        }

        main,
        header {
          padding-inline: ${rem(20)};
        }
      }
    }

    :where(header) {
      font-weight: bold;
    }

    :where(.loaderBackground) {
      background-color: ${color('white')};
      opacity: 0.9;
    }

    :where(.loading) {
      display: flex;
      justify-content: center;
    }

    :where(.loading, .loaderBackground) {
      block-size: 100%;
      inline-size: 100%;
      inset-block-start: 0;
      position: absolute;
    }
  `,
];
